// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1OepK","buttons":"SendReceipts_buttons__3HId8","email":"SendReceipts_email__2m8Ml","bookApptTitle":"SendReceipts_bookApptTitle__1cBCY"};